import { FC } from 'react';

import { UserProfileData } from '@/components/organisms';
import { ProfilePopupItem } from '@/components/organisms/UserDetailsPopup/components/ProfilePopupItem';

type ProfileTabProps = {
  user: UserProfileData;
};

export const ProfileTab: FC<ProfileTabProps> = ({ user }) => {
  return (
    <div className="flex">
      <div className="w-[260px] space-y-5 mt-5">
        <ProfilePopupItem label="Job title" content={user.jobTitle} />
        <ProfilePopupItem label="Email" content={user.email} />
        <ProfilePopupItem label="Tenure" content={user.tenure} />
        <ProfilePopupItem label="Location" content={user.location} />
        <ProfilePopupItem label="Date format" content={user.dateFormat} />
      </div>
      <div className="w-[260px] space-y-5 mt-5">
        <ProfilePopupItem label="Department" content={user.department} />
        <ProfilePopupItem label="Gender" content={user.gender} />
        <ProfilePopupItem label="Managers name" content={user.managersName} />
        <ProfilePopupItem label="Timezone" content={user.timezone} />
        <ProfilePopupItem label="Language" content={user.language} />
      </div>
    </div>
  );
};
